import { Injectable, NgZone } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogComponent, ConfirmDialogConfig, ConfirmDialogData } from '@go-modules/components/dialogs/confirm-dialog/confirm-dialog.component';
import { TermsOfUseDialogComponent } from '@go-modules/components/dialogs/terms-of-use-dialog/terms-of-use-dialog.component';
import { MessageDialogComponent, MessageDialogData } from '@go-modules/components/dialogs/message-dialog/message-dialog.component';
import { CompareProductsDialogComponent, LicenseProductChooserData } from '@go-modules/components/dialogs/compare-products-dialog/compare-products-dialog.component';
import { AccountLockoutDialogComponent, AccountLockoutDialogData } from '../../components/dialogs/account-lockout-dialog/account-lockout-dialog.component';
import { InviteUsersDialogComponent, InviteUsersDialogData } from '@go-modules/components/dialogs/invite-users-dialog/invite-users-dialog.component';

/**
 * A service used to open an ngx modal in ng1
 * we also have ngxGoModalService but that doesnt work for modals not using GoDialogRef and GO_MODAL_DATA
 * can add additional modals as needed
 */
@Injectable({
	providedIn: 'root'
})
export class DowngradeModalService {
	constructor (
		private dialog: MatDialog,
		private ngZone: NgZone
	) {}

	public openConfirmDialog (data: ConfirmDialogData, config: ConfirmDialogConfig = {}): Promise<boolean> {
		return new Promise<boolean>((resolve, reject) => {
			this.ngZone.run(() => {
				const dialogRef = this.dialog.open(ConfirmDialogComponent, {...config, data});
				dialogRef.afterClosed().subscribe((confirm: boolean) => {
					if (confirm) {
						resolve(true);
					} else {
						reject(new Error('DowngradeModalService::openConfirmDialog'));
					}
				});
			});
		});
	}

	public inviteUsersDialog (data: InviteUsersDialogData) {
		return new Promise<any>((resolve, reject) => {
			this.ngZone.run(() => {
				const dialogRef = this.dialog.open(InviteUsersDialogComponent, {data});
				dialogRef.afterClosed().subscribe((result) => {
					if (result) {
						resolve(result);
					} else {
						reject(new Error('DowngradeModalService::inviteUsersDialog'));
					}
				});
			});
		});
	}

	// TODO - remove when dashboardRootView ngx STAB-634
	public openTermsOfUseDialog () {
		this.ngZone.run(() => {
			return this.dialog.open(TermsOfUseDialogComponent);
		});
	}

	public openMessageDialog (data: MessageDialogData): MatDialogRef<MessageDialogComponent, boolean> {
		return this.ngZone.run(() => {
			return this.dialog.open(MessageDialogComponent, {data});
		});
	}

	// TODO - remove when licensePaymentWizardView STAB-810 licenseDetailsForm STAB-738 and LazyPaymentLoader STAB-984
	public openCompareProductsDialog (data: LicenseProductChooserData) {
		return this.ngZone.run(() => {
			return this.dialog.open(CompareProductsDialogComponent, {data});
		});
	}

	public openAccountLockoutDialog (data: AccountLockoutDialogData) {
		this.ngZone.run(() => {
			return this.dialog.open(AccountLockoutDialogComponent, {data});
		});
	}
}
